import * as React from 'react';
const NoSuchTab = ({ tab }) => React.createElement("p", null, `No tab found with name ${tab}`);
export default NoSuchTab;
